import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getValidationErrors, mapErrors, ValidationErrorMap } from 'icreate/common/validators';

@Component({
    selector: 'app-simple-input',
    templateUrl: './simple-input.component.html',
    styleUrl: './simple-input.component.css',
    standalone: false,
})
export class SimpleInputComponent {
    @Input() inputValue;
    @Input() propertyName: string;
    @Input() validatorFunction;
    @Input() placeholder: string;
    @Input() maxlength: number;
    @Input() rightText: string;
    @Input() icon: string;
    @Input() isNumberInput: boolean = false;
    @Input() errorIsAbsolute: boolean = false;
    @ViewChild('inputRef') inputRef: ElementRef<HTMLInputElement>;

    @Output() onInputUpdated: EventEmitter<any> = new EventEmitter();

    isFocused: boolean = false;
    validationErrors: ValidationErrorMap = {};

    constructor(private translateService: TranslateService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.inputValue) {
            if (!changes.inputValue?.isFirstChange()) {
                this.checkInputErrors();
            }
        }
        if (changes.propertyName) {
            if (!changes.propertyName?.isFirstChange()) {
                this.checkInputErrors();
            }
        }
    }

    hasErrorString() {
        return this.propertyName in this.validationErrors;
    }

    get errorString() {
        if (this.propertyName in this.validationErrors) {
            const err = this.validationErrors[this.propertyName];
            return this.translateService.instant(err.errors[0], err.params);
        }
        return;
    }

    inputFocus() {
        this.isFocused = true;
    }

    inputBlur() {
        this.isFocused = false;
        this.checkInputErrors();
    }

    handleChange() {
        if (this.isNumberInput) {
            const hasAll0 = /^0+$/.test(String(this.inputValue).trim());
            if (isNaN(this.inputValue) || hasAll0) {
                this.inputValue = 0;
                if (this.inputRef) this.inputRef.nativeElement.value = this.inputValue;
            }
        }

        this.onInputUpdated.emit(this.inputValue);
        this.checkInputErrors();
    }

    checkInputErrors() {
        const object = {};
        object[this.propertyName] = this.inputValue;
        if (this.isNumberInput) object[this.propertyName] = Number(this.inputValue);

        const errors = this.validatorFunction ? getValidationErrors(this.validatorFunction, object) : null;

        if (errors) {
            this.validationErrors = mapErrors(errors);
        }

        this.onInputUpdated.emit(this.inputValue);
    }
}
